import mitt from "mitt"
export const portalEvents = mitt()
